import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BspiHeader, BspiFooter } from '../bspi/HomeSections';
import './InsightPage.css';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const InsightsIndex = () => {
  const [items, setItems] = useState([]);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API_URL}/api/public/insights`);
        if (res.ok) {
          setItems(await res.json());
          setStatus('ok');
        } else { setStatus('error'); }
      } catch { setStatus('error'); }
    })();
    document.title = 'Insights | Black Star PI';
  }, []);

  return (
    <>
      <div className="bspi chrome-only"><BspiHeader /></div>
      <div className="bspi-insight" data-testid="insights-index">
        <article className="page">
          <header className="masthead">
            <a className="brand-link" href="/">
              <img src="/insights/liquidity-illusion/brand-logo.png" alt="Black Star PI" width="310" height="74" />
            </a>
            <div className="masthead-link">Executive Property Investment Insight</div>
          </header>

        <main style={{ paddingTop: 60 }}>
          <div className="section-label" style={{ color: '#b78a2e', marginBottom: 12 }}>Insights</div>
          <h1 style={{
            fontFamily: '"Courier New", monospace', fontSize: 'clamp(40px, 4vw, 56px)',
            fontWeight: 600, letterSpacing: '-0.05em', color: '#062f2a', margin: '0 0 42px'
          }}>
            Editorial intelligence on property, capital and structure.
          </h1>

          {status === 'loading' && <p style={{ color: '#65706b' }}>Loading…</p>}
          {status === 'error' && <p style={{ color: '#65706b' }}>Unable to load insights right now.</p>}

          {status === 'ok' && items.length === 0 && (
            <p style={{ color: '#65706b' }}>No articles yet — check back soon.</p>
          )}

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 32 }}>
            {items.map((item) => (
              <Link
                key={item.slug}
                to={`/insights/${item.slug}`}
                data-testid={`insight-card-${item.slug}`}
                style={{
                  display: 'block', textDecoration: 'none', color: 'inherit',
                  border: '1px solid #d8d1c2', background: '#fffdf8', overflow: 'hidden',
                  transition: 'transform .2s, box-shadow .2s',
                }}
                onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 18px 40px rgba(23,51,46,0.12)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = ''; }}
              >
                {item.hero_image && (
                  <div style={{ aspectRatio: '16 / 9', overflow: 'hidden', background: '#062f2a' }}>
                    <img src={item.hero_image} alt={item.hero_alt || item.title}
                         style={{ width: '100%', height: '100%', objectFit: 'cover' }} loading="lazy" />
                  </div>
                )}
                <div style={{ padding: 22 }}>
                  {item.category && (
                    <div style={{
                      fontSize: 10, letterSpacing: '.18em', textTransform: 'uppercase',
                      color: '#b78a2e', marginBottom: 10,
                    }}>{item.category}</div>
                  )}
                  <h3 style={{
                    fontFamily: '"Courier New", monospace', fontSize: 22, letterSpacing: '-.04em',
                    color: '#062f2a', margin: '0 0 10px', lineHeight: 1.15, fontWeight: 600,
                  }}>{item.title}</h3>
                  {item.standfirst && (
                    <p style={{ fontFamily: 'Georgia, serif', fontSize: 15, color: '#29332f', margin: '0 0 14px' }}>
                      {item.standfirst}
                    </p>
                  )}
                  <div style={{ fontSize: 11, letterSpacing: '.05em', color: '#65706b' }}>
                    {item.author}{item.author && item.reading_time ? ' · ' : ''}{item.reading_time}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </main>

        <footer className="insight-footer" style={{ marginTop: 60 }}>
          <div className="footer-brand">
            <a className="footer-logo-link mark" href="/">
              <img className="footer-logo mark" src="/insights/liquidity-illusion/footer-mark.png" alt="Black Star PI" />
            </a>
            <span className="footer-copy">Published by Black Star PI Ltd</span>
          </div>
          <a className="site-link" href="/">black-starpi.com</a>
        </footer>
        </article>
      </div>
      <div className="bspi chrome-only"><BspiFooter /></div>
    </>
  );
};

export default InsightsIndex;
